// import AuthLayout from "../../components/";
import {
    Button,
    Col,
    Image,
    Layout,
    List,
    Row
} from "antd";
import {
    FaCheckCircle
} from "react-icons/fa";
import { useNavigate } from "react-router";
import { ImageUrl } from "../../helpers/Function";
import { useEffect } from "react";
// import router from "next/router";

function OccupationalHealthAndSafetyAdministrationOsha() {
    const navigate = useNavigate();

    const data1 = [
        {
            title: "Attach a logo to the portal.",
        },
        {
            title: "Create a referral code for users to self-enroll into a portal.",
        },
    ];

     useEffect(() => { window.scrollTo(0, 0); }, []);
    return (
        <>
            
            <Layout style={{ minHeight: "100vh", backgroundSize: "cover" }}>
                <section className="bg-white top-bottom-padding two-colum-white">
                    <Row justify={"center"}>
                        <Col lg={19}>
                            <Row
                                justify={"center"}
                                gutter={[32, 32]}
                                className="gutter-0"
                            >
                                <Col xs={24} sm={24} md={12}>
                                    <div className="c-img">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("c27.png")}

                                        />
                                    </div>
                                </Col>
                                <Col xs={24} md={12}>
                                    <div className="">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("miniImg4.png")}
                                        />
                                        <h4>OSHA Hazardous Materials “Community Chemical Right to Know”</h4>
                                        <p className="text-p-16">
                                        Duration:2 Hours 30 Minutes
                                        </p>
                                        <h5 className="c-heading">Who Should Attend</h5>
                                        <p className="text-p-16">
                                        Teachers, Assistant Teachers, Family Service Staff, Nutrition Staff, Custodial Supervisor, Custodial Staff
                                        </p>

                                        <h5 className="c-heading">Description</h5>

                                        <p className="text-p-16">
                                        The OSHA Hazard Communication (HazCom): Chemical Right to Know training focuses on providing participants with a comprehensive understanding of the hazards associated with chemical use. The training is designed to ensure that information regarding chemical hazards is effectively communicated to employers and employees. It specifically addresses the unique considerations for early care and education programs, equipping participants with the knowledge and skills to mitigate potential exposures. Key topics covered include hazard labeling, safety data sheet interpretation, and proper usage and disposal of personal protective equipment (PPE).
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </section>


                <section className="bg-white top-bottom-padding two-colum-white">
                    <Row justify={"center"}>
                        <Col lg={19}>
                            <Row
                                justify={"center"}
                                gutter={[32, 32]}
                                className="gutter-0"
                            >
                                <Col xs={24} sm={24} md={12}>
                                    <div className="c-img">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("c28.png")}

                                        />
                                    </div>
                                </Col>
                                <Col xs={24} md={12}>
                                    <div className="">
                                        <Image
                                            preview={false}
                                            alt={"Failed to load image"}
                                            src={ImageUrl("miniImg4.png")}
                                        />
                                        <h4>OSHA Universal Precautions “Bloodborne Pathogens and Bodily Fluids”</h4>
                                        <p className="text-p-16">
                                        Duration: 2 Hours 30 Minutes
                                        </p>
                                        <h5 className="c-heading">Who Should Attend</h5>
                                        <p className="text-p-16">
                                        Teachers, Assistant Teachers, Family Service Staff, Nutrition Staff, Custodial Supervisor, Custodial Staff
                                        </p>

                                        <h5 className="c-heading">Description</h5>

                                        <p className="text-p-16">
                                        The OSHA Universal Precautions: Bloodborne Pathogens and Bodily Fluids Compliance Training is specifically designed to provide participants with a comprehensive understanding of OSHA’s regulatory requirements pertaining to bloodborne pathogens. This training focuses on key topics such as Hepatitis B and AIDS viruses, their modes of transmission, and the necessary precautions to ensure a safe and compliant workplace.
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </section>

               


            </Layout>
        </>
    );
}

export default OccupationalHealthAndSafetyAdministrationOsha;
